var staticGalleryView = {
};

function galleryView(id,props) {
	this.ident = id;
	this.properties = props;
	this.max = 1;
	this.menu = null;
	this.menuOverlay = null;
	this.wWidth = 0;
	this.wHeight = 0;
	this.menu_title = "";
	this.autoplaying = false;
	this.autotimer = null;
	
	while (this.properties.properties['image_' + this.max] != undefined && this.properties.properties['image_' + this.max] != "") {
		this.max ++;
	}	
	
	//console.log("images: " + this.max);
	
	this.max --;
	
	//swipe = new swiper();
	
	//$("#menubutton").hide();
	//$("#menu").hide();

	this.wWidth = $(window).width();
	this.wHeight = $(window).height();

	//$("#mapbutton").show();	
	this.playnode = $("<div></div>");//$("<a href='javascript:void(null)' onclick='staticGalleryView.self.toggleAuto();' ontouchend='staticGalleryView.self.toggleAuto();' id='playstop' style='position:absolute;right:5px;bottom:5px;pointer-events:all;'><img src='assets/menu_next.png' width='84' height='84'></a><Br>");
	$("#overlay").append(this.playnode);
	
	player.bottomBar(false);

	$("#info").hide();
}

galleryView.prototype = {
	current:1,
	
	load: function() {
		AppEvent.trigger(player, "PLACE.LOADED", player.currentView);

		$("#player").css("background-color","#000000");
		$("#player").html("");
		$("#menubutton").hide();
		
		staticGalleryView.self = this;
		
		if (this.properties.gallery != undefined) this.menu = this.properties.gallery.menu;
		
		//console.log(this.properties);

		this.content = $("<Div id='galcontent'></div>");
		$("#player").append(this.content);
		this.node = new css3DNode("#galcontent");

		this.close = $("<img src='assets/menu_close.png' class='mobileonly' width='50' height='50' style='z-index:99999;position:absolute;right:10px;top:10px;'>");
		$("#player").append(this.close);

		this.close.on(Events.pointer.up, function() {
			player.go(player.lastIdent, 0);
		});
		//this.content.css("width", "1800px");
		//this.content.css("left", "-400px");

		var tw = $(window).width() * 0.2;
		if (tw < 130) tw = 100;
		var th = tw * 0.5;
		
		/*
		for(var i = 0; i < this.properties.properties.gallery.length; i ++) {
			var photo = this.properties.properties.gallery[i];
			this.content.append($("<div class='galthumb' ontouchend='staticGalleryView.self.open(" + i + ")'><img src='" + photo.thumb + "' width='" + tw + "' height='" + th + "'></div>"));
		}
		this.w = this.content.width();
		this.h = this.content.height();
		
		if (this.h > $(window).height()) this.content.css("width", (this.w * 2) + "px");
		//this.content.css("height", (this.h - 50) + "px");
		
		this.w = this.content.width();
		this.h = this.content.height();
		*/
		
		this.overlay = $("<div id='galoverlay'></div>");
		$("#player").append(this.overlay);
		
		this.menuOverlay = $("<div id='galmenu'><h2 id='galtoptitle'>" + this.menu_title + "</h2></div>");		
		var mcnt = $("<div id='galmenucontent'></div>");
		this.menuOverlay.append(mcnt);
				
		$("#player").append(this.menuOverlay);

		this.nav = $("<div id='#galnav'><a href='javascript:void(null);' id='galleft' onclick='staticGalleryView.self.previous();' title='Poprzednie zdjęcie'><img src='assets/l_arrow.png'></a><a href='javascript:void(null);' id='galright' onclick='staticGalleryView.self.next();' title='Następne zdjęcie'><img src='assets/r_arrow.png'></a></div>");
		$("#player").append(this.nav);

		this.menuController = new VerticalList("#galmenucontent");
		
//		console.log("Opening 1");
		this.open(1);

		Tab.clearGroup("hotspots");
		Tab.add("hotspots", Tab.simpleTab($("#galleft"), 0), {});
		Tab.add("hotspots", Tab.simpleTab($("#galright"), 1), {});

		AppEvent.trigger(player, "PLACE.LOADED", player.currentView);
	},
	
	open: function(id) {
		//if (swipe.isScrolling()) return;
		
		player.preload(true);
		
		var photos = staticGalleryView.self.properties.properties;				
		var menu_title = "";
		
		var title = photos['tooltip_' + id];
		var thumb = photos['image_' + id];
		var desc = photos['description_' + id];
		
		if (desc != "") {
			$("#g-photodesc").html(desc);
			$("#g-photodesc").show();
			/*
			$("#menubutton").show();
			placeInfo.setDesc(title, desc);
			*/
		} else {
			$("#photodesc").hide();
		}
		 
		this.current = id;
		
		//var url = "index.php?id=" + photo.id;
		//document.title = "clicked(" + id + ")";
		
		if (this.menu != null) {
			for(var i = 0; i < this.menu.length; i ++) {
				if (this.menu[i].id == player.ident) menu_title = this.menu[i].title;
			}
		}
		
		this.menu_title = menu_title; // staticGalleryView.self.hideMenu();
		$("#galtoptitle").html("<div class='folder' style='border-bottom:2px solid #ffffff;'><a href='javascript:void(null);' ontouchend='navbar.openMenu();staticGalleryView.self.hideMenu();'><div class='lglyph'>&laquo;</div><b>Galeria</b></a></div>");
		
		/*
		if (menu_title.length > 9 && this.wWidth < 400) {
			menu_title = menu_title.substr(0, 9) + "...";
		}
		*/	
				
		if (this.menu != null) {
			this.overlay.html("<div id='galtitle'><a href='javascript:void(null);' onclick='staticGalleryView.self.showMenu();' class='currentMenuButton'><img src='assets/current_menu.png?20131125' width='12' height='12'><span>" + menu_title + "</span></a> <img src='assets/right_arrow.png' width='16' height='16' style='vertical-align:middle;'> <div id='upphototitle'>" + title + "</div> (" + this.current + " / " + this.max + ")" + "</div><div id='galbig'><div id='g-holder'><img src='' id='full' title='" + title + "' alt='" + title + "'><div id='g-photodesc'>" + desc + "</div><a href='javascript:void(null);' id='g-info'><i class='fa fa-info'></i></a></div><div id='downphototitle'>" + title + "</div></div>");
		} else {
//			this.overlay.html("<div id='galtitle'>" + title + " (" + this.current + " / " + this.max + ")" + "</div><div id='galbig'><img src='' id='full'></div><div id='galleft'><img src='assets/l_arrow.png' ontouchend='staticGalleryView.self.previous();'></div><div id='galright'><img src='assets/r_arrow.png' ontouchend='staticGalleryView.self.next();'></div><div id='downphototitle'>" + title + " (" + this.current + " / " + this.max + ")" + "</div>");
			this.overlay.html("<div id='galtitle'>" + title + " (" + this.current + " / " + this.max + ")" + "</div><div id='galbig'><img src='' id='full' title='" + title + "' alt='" + title + "'></div>");
		}

		if (desc != "") $("#g-info").show(); else $("#g-info").hide();

		$("#g-info").on(Events.pointer.up, function() {
			$("#g-info").toggleClass("g-collapse");
			$("#g-photodesc").toggleClass("g-visible");

			if (!$("#g-info").hasClass("g-collapse"))
				$("#g-info").html("<i class='fa fa-info'></i>");
			else
				$("#g-info").html("<i class='fa fa-times'></i>");
		});

//		this.overlay.html("<div id='galbig'><img src='' id='full'></div><div id='galleft'><img src='assets/l_arrow.png' ontouchend='staticGalleryView.self.previous();'></div><div id='galright'><img src='assets/r_arrow.png' ontouchend='staticGalleryView.self.next();'></div>");
//		this.overlay.html("<div id='galleft'><img src='assets/l_arrow.png' ontouchend='staticGalleryView.self.previous();'></div><div id='galright'><img src='assets/r_arrow.png' ontouchend='staticGalleryView.self.next();'></div>");
		
		$("#player").width(this.wWidth + "px");
		$("#player").height(this.wHeight + "px");
		
		var im = new Image();
		im.onload = function() {
			
			//alert("onload");
		
			this.wHeight = staticGalleryView.self.wHeight;
			this.wWidth = staticGalleryView.self.wWidth;
						
			$("#full").attr("src", im.src);
			
			if ($("#full").height() > this.wHeight - 0) { // margines pionowy - 0 wczesniej 180
				var fh = $("#full").height();
				var fw = $("#full").width();
				$("#full").height(this.wHeight - 0);
				$("#full").width(fw * ($("#full").height() / fh));
			}
						
			if ($("#full").width() > this.wWidth) {
				var fh = $("#full").height();
				var fw = $("#full").width();
				$("#full").width(this.wWidth);
				$("#full").height(fh * ($("#full").width() / fw));
			}
						
			$("#downphototitle").css("width",$("#full").width());
						
			//setTimeout(function() {
				//document.title = $(window).height() + " , " + $("#galbig").height();
				var top = (this.wHeight * 0.5 - $("#galbig").height() * 0.5);
				$("#galbig").css("margin-top",(this.wHeight * 0.5 - $("#galbig").height() * 0.5) + "px");
				$("#galbig").css("margin-left",(this.wWidth * 0.5 - $("#full").width() * 0.5) + "px");
				$("#galbig").css("opacity", "1");			
			//	}, 100);
			
			player.redraw();
			player.preload(false);
		};
				
		if (player.offline)			
//			im.src = "data/" + thumb.replace("..\/data\/", "");
			im.src = thumb.replace("..\/data\/", "");
		else
			im.src = "../" + thumb;

		//$("#full").attr("src", "../" + photo.path);
		this.overlay.show();
		this.opened = true;
		
		//$("#menu").hide();
		//$("#menubutton").hide();

	},

	hideMenu: function() {
		this.menuOverlay.hide();
		//$("#menu").show();
		
		player.redraw();
	},
	
	go: function(id, dir) {
		//if (staticGalleryView.self.scroll.isScrolling()) {
		//	return;
		//}		
		player.go(id, dir);
	},
	
	showMenu: function() {
		this.menuOverlay.show();		
		//$("#menu").hide();
		
		var mcnt = $("#galmenucontent");		
		//mcnt.html("");
		this.menuController.clear();
		
		player.redraw();		
		//this.menuOverlay.append("<a href='javascript:void(null);' onclick='staticGalleryView.self.hideMenu();'>&lt;&lt;</a><br><Br>");
		
		for(var i = 0; i < this.menu.length; i ++) {
			this.menuController.add({html:"<div class='folder'><a href='javascript:void(null);' class='menuitem' data-itemtap='staticGalleryView.self.go(" + this.menu[i].id + ", " + (this.menu[i].dir == undefined?0:this.menu[i].dir) + ");'>" + this.menu[i].title + "</a></div>"});
//			this.menuController.add({html:"<div class='folder'><a href='javascript:void(null);' data-itemtap='staticGalleryView.self.go(" + this.menu[i].id + ", " + (this.menu[i].dir == undefined?0:this.menu[i].dir) + ");'>" + this.menu[i].title + "</a></div>"});			
			//mcnt.append("<div class='folder'><a href='javascript:void(null);' data-itemtap='staticGalleryView.self.go(" + this.menu[i].id + ", " + (this.menu[i].dir == undefined?0:this.menu[i].dir) + ");'>" + this.menu[i].title + "</a></div>");
		}
		
		this.menuController.bindEvents();
		
		var cb = $("<div class='centerButton mobileonly'><a href='javascript:void(null);' ontouchend='staticGalleryView.self.hideMenu();'><img src='assets/back.png' height='84' width='84'></a></div>");
		this.menuOverlay.append(cb);
		
		//this.scroll = new Scroller("#galmenucontent", "#galmenu");
	},
	
	next: function() {
		if (this.current == this.max) this.current = 0;
		this.open(this.current + 1);
	},
	
	previous: function() {
		if (this.current == 1) this.current = this.max + 1;
		this.open(this.current - 1);
	},
	
	reorient: function() {
		this.wWidth = $(window).width();
		this.wHeight = $(window).height();
		this.open(this.current);
	},
	
	process: function() {
	},
		
	toggleAuto: function() {
		this.autoplaying = !this.autoplaying;
		
		if (this.autoplaying) {
			$("#playstop").html("<img src='assets/menu_reload.png' width='84' height='84' class='blink'>");
			this.autoplay();
		} else {
			$("#playstop").html("<img src='assets/menu_next.png' width='84' height='84'>");
			if (this.autotimer != null) clearTimeout(this.autotimer);
			this.autotimer = null;
		}
	},
		
	autoplay: function() {		
		if (staticGalleryView.self.autoplaying) {
			staticGalleryView.self.next();
			staticGalleryView.self.autotimer = setTimeout(staticGalleryView.self.autoplay, 5000);
		}
	},
		
	mouseDown: function(event) {
		this.panning = true;
//		swipe.start(event.originalEvent.touches);
	},
	
	mouseUp: function(event) {
//		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
//		swipe.move(event.originalEvent.touches);
	},

	mouseWheel: function(dt) {
	},
	
	pause: function() {
		this.paused = true;
	},

	resume: function() {
		this.paused = false;
	},

	leaving: function() {		
		player.bottomBar(true);
		this.playnode.remove();

		var self = this;

		AppEvent.one(player, "PLACE.TRANSITIONED", function() {
			self.menuOverlay.remove();
			self.overlay.remove();
			self.nav.remove();
			self.content.remove();
			self.close.remove();
		});
	}

}